import type { PublicSportType } from '@/features/sport-types/api/sportTypesApi'

export function normalizeLeaderboardSportCode(code: string): string {
  return code.trim().toUpperCase()
}

export function resolveLeaderboardSportApiValue(
  sport: string
): string | undefined {
  if (sport === 'all') return undefined
  return normalizeLeaderboardSportCode(sport)
}

export function isLeaderboardSportTabValue(
  sport: string,
  sportTypes: PublicSportType[]
): boolean {
  if (sport === 'all') return true
  const normalized = normalizeLeaderboardSportCode(sport)
  return sportTypes.some(
    item => normalizeLeaderboardSportCode(item.code) === normalized
  )
}
